export const M6_HR = () : React.JSX.Element => {
    return(
        <>
            <p className="NonIndented"><b>Partneri</b></p>
            <div className="LinkContainer">
                <div className="LinkContainerItFromBit"><a href="https://itfrombit.biz/" target="_blank"><div className="ItFromBit" /></a></div>
                <div className="LinkContainerTN"><a href="https://www.true-north.hr/" target="_blank"><div className="TN" /></a></div>
            </div><br/><br/>
            <p className="NonIndented"><b>Klijenti</b></p>
            <div className="LinkContainer">
                <div className="LinkContainerHKZP"><a href="https://www.crocontrol.hr/" target="_blank"><div className="HKZP" /></a></div>
            </div>
        </>
    );
}